export class CPARSearchRequest {
    constructor(public precedentId?: string,
                public externalInstId?: string,
                public externalUnitTitle?: string,
                public externalUnitCode?: string,
                public externalYearCompleted?: string) {
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/CPARSearchRequest.ts